// Hub page content for the Review & Appeals group.
// Sourced from docs/research/australian-visa-pathways.md §9.

const reviewAppealsHub = {
  groupSlug: "review-appeals",
  eyebrow: "Review & Appeals",
  heading: "Visa refusals and cancellations",
  intro:
    "A refusal or cancellation is stressful, but it is often not the end. Many decisions can be reviewed by the Administrative Review Tribunal, which replaced the AAT in late 2024. The one thing that matters most is speed: the time limits are short and strict. We read the letter with you, flag the deadline, and get you to a registered migration agent fast, then gather the documents they need. A registered migration agent confirms your review rights, lodges, and represents you.",

  howItWorks: {
    heading: "How review works",
    steps: [
      {
        title: "Read the decision with you",
        detail:
          "We read the letter with you and flag the exact deadline, then get you to a registered migration agent fast.",
      },
      {
        title: "Check review rights",
        detail:
          "A registered migration agent confirms whether the decision can be reviewed and who is entitled to apply.",
      },
      {
        title: "Lodge in time",
        detail:
          "A registered migration agent lodges with the ART within the strict window. Missing it usually ends the review right. We chase the documents so nothing stalls.",
      },
      {
        title: "Present your case",
        detail:
          "The ART re-considers the decision on its merits. A registered migration agent prepares and presents the case, and we keep gathering what they ask for.",
      },
    ],
  },

  atAGlance: {
    heading: "Compare review situations",
    columns: ["Situation", "What happens", "Decided by", "Urgency"],
    rows: [
      {
        serviceSlug: "visa-refusals",
        cells: [
          "Visa Refusals",
          "A registered migration agent seeks merits review of a refused application",
          "The ART",
          "Lodge within a short, strict window",
        ],
      },
      {
        serviceSlug: "visa-cancellations",
        cells: [
          "Visa Cancellations",
          "A registered migration agent responds to or seeks review of a cancellation",
          "The Department, reviewable at the ART",
          "Often only days to act",
        ],
      },
    ],
  },

  faqs: [
    {
      q: "How quickly do I need to act?",
      a: "Very quickly. The time limits to seek review are short and strict, commonly around 21 to 28 days for refusals and sometimes only days for cancellations. Do not wait. Contact us as soon as you receive a decision, and we get you to a registered migration agent fast.",
    },
    {
      q: "Will an appeal definitely fix things?",
      a: "No. The ART is independent and decides on the merits, and there is a significant backlog, so reviews can take well over a year. No one can guarantee the outcome. A registered migration agent gives you an honest assessment and puts the case forward, and we keep the documents moving.",
    },
    {
      q: "What if the ART affirms the decision?",
      a: "There are limited further options, such as judicial review in the courts for legal error, or a discretionary request for Ministerial intervention. These are last resorts with strict rules. A registered migration agent, or a lawyer for judicial review, advises on them.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default reviewAppealsHub;
